import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { LiveRegion } from '@/components/feedback/LiveRegion';
import { Toaster } from '@/components/feedback/Toaster';
// Language switcher temporarily hidden from the UI (ADR-038). Do not delete.
// import { LanguageSwitcher } from '@/components/layout/LanguageSwitcher';
import { SafeArea } from '@/components/layout/SafeArea';
import { SkipLink } from '@/components/layout/SkipLink';
import { env } from '@/config/env';

// import { type Locale, LOCALE_LABELS, SUPPORTED_LOCALES } from '@/constants/locales';
// import { buildLocaleUrl } from '@/i18n/detectLocale';
// import { currentLocale } from '@/i18n/i18n';
// import { loadAndChangeLocale } from '@/i18n/loadLocale';
import { CheckoutFrame } from './CheckoutFrame';

// const LANGUAGE_OPTIONS = SUPPORTED_LOCALES.map((code) => ({
//   code,
//   label: LOCALE_LABELS[code],
// }));

export interface BareLayoutProps {
  children: ReactNode;
}

/**
 * Unbranded shell for screens that have no session: the entry-help page, invalid-link, and the
 * root error boundary. Same landmarks and live region as `CashierLayout` so those screens are not
 * a second, lesser accessibility tree.
 */
export function BareLayout({ children }: BareLayoutProps) {
  const { t } = useTranslation('common');
  // const active = currentLocale();

  // const handleLocale = (locale: Locale) => {
  //   void loadAndChangeLocale(locale).then((ok) => {
  //     if (!ok) return;
  //     window.history.replaceState(null, '', buildLocaleUrl(window.location.href, locale));
  //   });
  // };

  return (
    <div className="bg-surface-muted text-text flex min-h-dvh flex-col">
      <SkipLink label={t('a11y.skipToContent')} />
      <LiveRegion />
      <Toaster dismissLabel={t('actions.dismiss')} />
      <SafeArea className="flex min-h-dvh flex-1 flex-col">
        <CheckoutFrame
          mainProps={{ id: 'main-content', tabIndex: -1 }}
          header={
            <header className="border-border border-b px-4 py-2.5 sm:px-5">
              <p className="text-text truncate text-sm font-semibold">{env.appName}</p>
            </header>
          }
          footer={
            <footer className="border-border mt-auto flex flex-col gap-2 border-t px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] sm:px-5">
              <p className="text-text-muted text-center text-xs">{t('brand.poweredBy')}</p>
              {/* Language switcher temporarily hidden from the UI (ADR-038). Do not delete. */}
              {/*
              <LanguageSwitcher
                locales={LANGUAGE_OPTIONS}
                active={active}
                onSelect={handleLocale}
                label={t('footer.language')}
              />
              */}
            </footer>
          }
        >
          <div className="flex flex-1 flex-col justify-center">{children}</div>
        </CheckoutFrame>
      </SafeArea>
    </div>
  );
}
